import { $subscriber, interact } from "fire-wind-water";
import * as sbaseData from "../common/sbase";
import service from "../service/form";
import { $extras, $messageLoad } from "../../stempcore/src/core/sextra.js";
import { forkJoin } from "rxjs";
import { fixUrl } from "../common/sbase";
// import settingPC from "@/sktempjson/templateNew-pc.json";
// import settingWAP from "@/sktempjson/template-wap.json";

export default {
  data() {
    return {
      extras: {},
    };
  },
  methods: {
    initConfig() {
      sbaseData.init();
      // debugger
      // if (process.env.NODE_ENV === "development") {
      //   const html = interact.isMobile ? settingWAP.html : settingPC.html;
      //   this.extras = $extras(html).extras;
      //   this.$store.commit("setExtras", this.extras);
      //   window.$sk.loading.hide();
      //   return;
      // }

      if (!this.tenantId) {
        return;
      }

      const param = {
        tenantId: this.tenantId,
        configId: !sbaseData.isSetting
          ? this.formInfo.template[interact.isMobile ? "mobile" : "pc"].configId
          : sbaseData.configId,
      };

      const param2 = {
        tenantId: this.tenantId,
        configId: !sbaseData.isSetting
          ? this.formInfo.template[interact.isMobile ? "pc" : "mobile"].configId
          : sbaseData.sconfigId,
      };

      if (!param2.configId && Object.keys(this.extras).length != 0) {
        return;
      }

      if (param2.configId) {
        forkJoin(
          service.getTemplateConfig(param),
          service.getTemplateConfig(param2)
        ).subscribe((res) => {
          if (res.length > 1 && res[0].result == 0 && res[1].result == 0) {
            // if (Object.keys(this.extras).length != 0) {
            //   return;
            // }
            // this.extras = $extras(settingPC.html).extras;
            //是配置页面的时候就取另一个设备的配置

            if (!fixUrl(res[0].content.info)) {
              return;
            }
            if (sbaseData.isSetting && !sbaseData.isOverPrivew) {
              this.extras = $extras(res[1].content.info.html).extras;
            } else {
              this.extras = $extras([
                ...res[1].content.info.html,
                ...res[0].content.info.html,
              ]).extras;
            }

            if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
              let themeColorClear = "";
              const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
              if (rgbaAttr.length >= 3) {
                let r, g, b;
                r = rgbaAttr[0];
                g = rgbaAttr[1];
                b = rgbaAttr[2];
                themeColorClear =
                  "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
              }

              document.body.style.setProperty(
                "--themeColor",
                this.extras.themecolor.bgcolor
              );
              document.body.style.setProperty(
                "--themeColorClear",
                themeColorClear
              );
            }
            this.$store.commit("setExtras", this.extras);

            //this.extras.formfield.model = 'style1-wap'
          } else {
            window.$sk.tips.show("接口获取失败");
          }
        });
      } else {
        service.getTemplateConfig(param).subscribe((res) => {
          if (res.result == 0) {
            // if (Object.keys(this.extras).length != 0) {
            //   return;
            // }
            // this.extras = $extras(settingPC.html).extras;
            // debugger
            if (!fixUrl(res.content.info)) {
              return;
            }
            this.extras = $extras(res.content.info.html).extras;
            if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
              let themeColorClear = "";
              const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
              if (rgbaAttr.length >= 3) {
                let r, g, b;
                r = rgbaAttr[0];
                g = rgbaAttr[1];
                b = rgbaAttr[2];
                themeColorClear =
                  "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
              }

              document.body.style.setProperty(
                "--themeColor",
                this.extras.themecolor.bgcolor
              );
              document.body.style.setProperty(
                "--themeColorClear",
                themeColorClear
              );
            }
            this.$store.commit("setExtras", this.extras);

            //this.extras.formfield.model = 'style1-wap'
          } else {
            window.$sk.tips.show(res.desc);
          }
        });
      }
    },
  },
  created() {
    sbaseData.init();
    console.log("# subscribe 'sk-template-config'.");
    $subscriber.subscribe("sk-template-config", (o) => {
      console.log("# catch 'sk-template-config' ...");
      // console.log("# o.data: ", JSON.stringify(o.data));
      this.extras = $extras(o.data).extras;
      if (this.extras.themecolor && this.extras.themecolor.bgcolor) {
        let themeColorClear = "";
        const rgbaAttr = this.extras.themecolor.bgcolor.match(/[\d.]+/g);
        if (rgbaAttr.length >= 3) {
          let r, g, b;
          r = rgbaAttr[0];
          g = rgbaAttr[1];
          b = rgbaAttr[2];
          themeColorClear = "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
        }

        document.body.style.setProperty(
          "--themeColor",
          this.extras.themecolor.bgcolor
        );
        document.body.style.setProperty("--themeColorClear", themeColorClear);
      }
      this.$store.commit("setExtras", this.extras);
    });
  },
  mounted() {
    console.log("# $messageLoad ...");
    $messageLoad(1);
  },
};
